import * as types from "../actions/actionsTypes";
import initialState from "./initialState";

export default function loggedinUserActivityDataReducer(state = initialState.loggedinUserActivityData, action) {
  switch (action.type) {
    case types.LOAD_LOGGEDIN_USER_ACTICITY_DATA_SUCCESS:
      return action.loggedinUserActivityData;
    default:
      return state;
  }
}
